// Global
import React from 'react';

// Lib
import { UserProfile } from 'src/.generated/UserProfile/ResetPassword.model';
import ResetPassword from './ResetPassword';
import styles from './ResetPassword.module.scss';
import usePlainTextWrapper from 'components/helpers/SitecoreWrappers/PlainTextWrapper/PlainTextWrapper';
import { useLinkWrapper } from 'components/helpers/SitecoreWrappers/LinkWrapper/LinkWrapper';
import useRichTextWrapper from 'components/helpers/SitecoreWrappers/RichTextWrapper/RichTextWrapper';
import useIsEditing from 'lib/hooks/sitecore/useIsEditing';

type ResetPasswordSitecoreProps = UserProfile.ResetPassword.ResetPassword_Component;

export const Default = ({ fields }: ResetPasswordSitecoreProps): JSX.Element => {
  const {
    resetPasswordTitle,
    newPasswordLabel,
    confirmPasswordLabel,
    resetPasswordButtonLabel,
    resetPasswordSuccessMessage,
    invalidPageSlugDescription,
    forgotPageLink,
    loginPageLink,
  } = fields || {};

  const isEditing = useIsEditing();

  const titleNode = usePlainTextWrapper({ field: resetPasswordTitle });
  const newPasswordLabelNode = usePlainTextWrapper({ field: newPasswordLabel });
  const confirmPasswordLabelNode = usePlainTextWrapper({ field: confirmPasswordLabel });
  const resetPasswordButtonLabelNode = usePlainTextWrapper({ field: resetPasswordButtonLabel });
  const resetPasswordSuccessMessageNode = usePlainTextWrapper({
    field: resetPasswordSuccessMessage,
  });
  const invalidPageSlugDescriptionNode = useRichTextWrapper({ field: invalidPageSlugDescription });
  const forgotPageLinkNode = useLinkWrapper({
    field: forgotPageLink,
    ctaStyle: 'filled',
    ctaVariant: 'brand',
    className: styles.requestNewPasswordLink,
  });
  const loginPageLinkNode = useLinkWrapper({
    field: loginPageLink,
    ctaStyle: 'filled',
    ctaVariant: 'brand',
    className: styles.loginLink,
  });

  if (!fields) {
    return <></>;
  }

  return (
    <ResetPassword
      title={titleNode}
      newPasswordLabel={newPasswordLabelNode}
      confirmPasswordLabel={confirmPasswordLabelNode}
      submitButtonText={resetPasswordButtonLabelNode}
      successMessage={resetPasswordSuccessMessageNode}
      loginLink={loginPageLinkNode}
      requestNewPasswordLink={forgotPageLinkNode}
      missingParamsMessage={invalidPageSlugDescriptionNode}
      isEditing={isEditing}
    />
  );
};
